import { css } from 'styled-components';

export interface WithDisplayProps {
  display?: string;
}

export const withDisplayCSS = ({ display }: WithDisplayProps) => css`
  ${display && `display: ${display};`}
`;
